import React from "react";
import {LucideIcon} from "lucide-react";

export interface EmptyStateProps {
    icon: LucideIcon;
    title: string;
    description?: string;
    action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({icon: Icon, title, description, action}) => (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
        <div className="size-14 rounded-2xl bg-surface-sunken flex items-center justify-center mb-4">
            <Icon size={24} strokeWidth={1.75} className="text-ink-faint"/>
        </div>
        <p className="text-sm font-semibold text-ink">{title}</p>
        {description && <p className="text-sm text-ink-muted mt-1 max-w-xs">{description}</p>}
        {action && <div className="mt-5">{action}</div>}
    </div>
);
